import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { PapiDeviation } from '@wix/da-papi-types';
import EllipsisIcon from '@wix/da-ds/pkg/Icons/Ellipsis';
import IconButtonWithContextMenu, {
  type IconButtonWithContextMenuProps,
} from '@wix/da-ds/pkg/Dropdown/Preset/IconButtonWithContextMenu';
import TierCreatorReduxModule from '../redux/creator/ModuleLoadable';
import TierConsumerReduxModule from '../redux/consumer/ModuleLoadable';
import { useTierContextMenuItems } from './hooks';
import DiscordModuleLoader from '../../Discord/redux/ModuleLoader';

export interface Props extends Omit<
  IconButtonWithContextMenuProps,
  'icon' | 'items' | 'onClick' | 'aria-label'
> {
  deviation: PapiDeviation;
  isOwner: boolean;
  className?: string;
  studioOrdering?: boolean;
  afterActionUrl?: string;
}

const MoreActionsButton: React.FC<Props> = ({
  isOwner,
  deviation,
  className,
  studioOrdering = false,
  afterActionUrl,
  ...rest
}) => {
  const { t } = useTranslation();
  const [hasMenuBeenOpened, setHasMenuBeenOpened] = useState(false);

  const items = useTierContextMenuItems(deviation, isOwner, studioOrdering, afterActionUrl);

  const handleInitialOpen = useCallback(() => {
    setHasMenuBeenOpened(true);
  }, []);

  return (
    <>
      <IconButtonWithContextMenu
        icon={EllipsisIcon}
        withBackground
        items={items}
        className={className}
        onClick={handleInitialOpen}
        aria-label={t('common.moreActions')}
        {...rest}
      />
      {
        // Load redux after the menu has been opened to prevent any page load performance impact
        hasMenuBeenOpened &&
          (isOwner ? (
            <TierCreatorReduxModule />
          ) : (
            <>
              <TierConsumerReduxModule />
              <DiscordModuleLoader />
            </>
          ))
      }
    </>
  );
};
MoreActionsButton.displayName = 'MoreActionsButton';

export default MoreActionsButton;
